/* qeslint-disable */

/* Over simplistic Event Dispatcher */

export class Do {
    private listeners: Set<(...args: any[]) => void> = new Set();

    do(callback: (...args: any[]) => void): void {
        this.listeners.add(callback);
    }

    undo(callback: (...args: any[]) => void): void {
        this.listeners.delete(callback);
    }

    fire(...args: any[]): void {
        this.listeners.forEach((l) => {
            l(...args);
        });
    }
}
